import React from "react";
import classnames from "classnames";

class WkRadio extends React.Component {
  state = { value: undefined };
  constructor(props) {
    super(props);
    this.state = {
      value: props.defaultValue,
    };
  }
  setValue(value) {
    this.setState((state) => ({
      ...state,
      value,
    }));
  }
  render() {
    const { options, onChange, background, radioItemClass } = this.props;
    const { value } = this.state;
    const radioBackground = background || "#FF5A31";

    const list = () => {
      return options.map((val) => {
        return (
          <RadioItem
            key={val.value}
            {...val}
            checked={val.value === value}
            radioItemClass={radioItemClass}
            onChange={(v) => {
              onChange && onChange(v);
              this.setValue(v);
            }}
            radioBackground={radioBackground}
          />
        );
      });
    };

    return <div className={"wk-radio"}>{list()}</div>;
  }
}
export default WkRadio;

export function RadioItem(props) {
  const {
    radioBackground,
    radioItemClass,
    children,
    label,
    value,
    checked,
    content,
    subTitle,
    onChange,
  } = props;

  return (
    <div>
      <div
        className={classnames("radio-item", radioItemClass)}
        onClick={() => {
          onChange && onChange(value);
        }}
      >
        <div className={"radio-left"}>
          <div className={"radio-check"}>
            <div className={"radio-border"} />
            <div
              style={{ background: radioBackground || "#FF5A31" }}
              className={classnames("radio-check-bar", checked && "check")}
            />
          </div>
          <span className={"radio-label"}>
            {label}
            {children}
          </span>
        </div>
        <div>{subTitle}</div>
      </div>
      {checked && <div>{content}</div>}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/wk/WkRadio.js